import { Loader2, Sparkles, Copy, Check } from 'lucide-react'
import type { ExpandedResult } from '../../types/promptcraft'

interface PromptCraftResultProps {
  expandedResult: ExpandedResult
  copied: boolean
  isRegenerating: boolean
  previewLoading: boolean
  onRegenerate: () => void
  onCopy: () => void
  onGeneratePreview: () => void
}

export function PromptCraftResult({
  expandedResult, copied, isRegenerating, previewLoading,
  onRegenerate, onCopy, onGeneratePreview,
}: PromptCraftResultProps) {
  return (
    <div className="bg-[#161b22] rounded-xl p-4 border border-cyan-900/30">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-lg font-medium text-white">📝 完整提示词</h3>
        <div className="flex items-center gap-2">
          <button
            onClick={onRegenerate}
            disabled={isRegenerating}
            className="px-3 py-1.5 bg-purple-900/20 text-purple-400 rounded-lg hover:bg-purple-900/40 transition-colors flex items-center gap-1.5 text-sm disabled:opacity-50 border border-purple-900/50"
          >
            {isRegenerating ? <Loader2 className="w-4 h-4 animate-spin" /> : <Sparkles className="w-4 h-4" />}
            重新生成提示词
          </button>
          <button
            onClick={onCopy}
            className="px-3 py-1.5 bg-cyan-900/20 text-cyan-400 rounded-lg hover:bg-cyan-900/40 transition-colors flex items-center gap-1.5 text-sm border border-cyan-900/50"
          >
            {copied ? <Check className="w-4 h-4 text-green-400" /> : <Copy className="w-4 h-4" />}
            {copied ? '已复制' : '复制'}
          </button>
          <button
            onClick={onGeneratePreview}
            disabled={previewLoading}
            className="px-3 py-1.5 bg-cyan-500/20 text-cyan-300 rounded-lg hover:bg-cyan-500/30 transition-colors flex items-center gap-1.5 text-sm disabled:opacity-50 border border-cyan-500/50"
          >
            {previewLoading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Sparkles className="w-4 h-4" />}
            预览图片
          </button>
        </div>
      </div>
      <div className="relative">
        <p className={`text-gray-300 text-sm leading-relaxed bg-[#0d1117] rounded-lg p-3 border border-cyan-900/20 ${isRegenerating ? 'opacity-50' : ''}`}>
          {expandedResult.full_prompt}
        </p>
        {isRegenerating && (
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="flex items-center gap-2 bg-[#161b22]/90 px-3 py-1.5 rounded-lg">
              <Loader2 className="w-4 h-4 animate-spin text-cyan-400" />
              <span className="text-cyan-400 text-sm">重新生成提示词...</span>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
